import { render, staticRenderFns } from "./CaseProcedures.vue?vue&type=template&id=685e1288&scoped=true&"
import script from "./CaseProcedures.vue?vue&type=script&lang=js&"
export * from "./CaseProcedures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e1288",
  null
  
)

export default component.exports